import { subDays, format } from 'date-fns'
import { GraphData } from '@app/@types/myEnergy'

const getDatesForWeekPeriod = (): GraphData => {
  const now = new Date()
  const yesterday = format(subDays(now, 1), 'dd MMM yyyy')
  const second = format(subDays(now, 2), 'dd MMM yyyy')
  const third = format(subDays(now, 3), 'dd MMM yyyy')
  const fourth = format(subDays(now, 4), 'dd MMM yyyy')
  const fifth = format(subDays(now, 5), 'dd MMM yyyy')
  const sixth = format(subDays(now, 6), 'dd MMM yyyy')
  return [[sixth], [fifth], [fourth], [third], [second], [yesterday], ['today']]
}

export default getDatesForWeekPeriod
